import { TwitterOutlined, InstagramOutlined, YoutubeOutlined, LinkedinOutlined, DiscordOutlined } from '@ant-design/icons';
import { Box, CardMedia, Container, Grid, Link, Stack, Typography, styled, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ReactComponent as LandingLogo } from 'assets/images/landing-logo.svg';

const FooterLink = styled(Link)(({ theme }) => ({
  fontFamily: 'Lato, sans-serif',
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.primary.main
  },
  '&:active': {
    color: theme.palette.primary.main
  }
}));

const SocialLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '0.875rem',
  fontWeight: 400,
  opacity: '0.6',
  cursor: 'pointer',
  '&:hover': {
    opacity: '1'
  }
}));

const socialMedias = [
  { component: TwitterOutlined, href: '#' },
  { component: YoutubeOutlined, href: '#' },
  { component: InstagramOutlined, href: 'https://www.instagram.com/knacksters/' },
  { component: DiscordOutlined, href: 'https://discord.gg/5WqKP6SDQf' },
  { component: LinkedinOutlined, href: 'https://www.linkedin.com/company/knacksters/about/' }
];

const Footer = () => {
  const theme = useTheme();

  return (
    <Box component="footer" sx={{ bgcolor: theme.palette.grey.A700, pt: 6, pb: 2 }}>
      <Container>
        <Grid container spacing={2} mb={8}>
          <Grid item xs={12} md={4}>
            <Stack spacing={{ xs: 3, md: 5 }}>
              <Link component={RouterLink} to="/" color="white" underline="none">
                <LandingLogo />
              </Link>
              <Typography
                sx={{
                  color: theme.palette.grey[400],
                  fontFamily: 'Lato, sans-serif'
                }}
              >
                Empowering your business with expert talent and AI-powered tools for unmatched results.
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container spacing={{ xs: 5, md: 2 }} justifyContent={{ md: 'flex-end' }}>
              <Grid item xs={6} sm={3}>
                <Stack spacing={{ xs: 3, md: 5 }}>
                  <Typography variant="h5" color="white" sx={{ fontWeight: 500, fontFamily: 'Lato, sans-serif' }}>
                    Quick Links
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 2.5 }}>
                    <FooterLink href="#" target="_blank" underline="none">
                      Home
                    </FooterLink>
                    <FooterLink href="#" target="_blank" underline="none">
                      User Dashboard
                    </FooterLink>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Stack spacing={{ xs: 3, md: 5 }}>
                  <Typography variant="h5" color="white" sx={{ fontWeight: 500, fontFamily: 'Lato, sans-serif' }}>
                    Help
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 2.5 }}>
                    <FooterLink href="#" target="_blank" underline="none">
                      Support Chat
                    </FooterLink>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Stack spacing={{ xs: 3, md: 5 }}>
                  <Typography variant="h5" color="white" sx={{ fontWeight: 500, fontFamily: 'Lato, sans-serif' }}>
                    Legal
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 2.5 }}>
                    <FooterLink href="/terms-of-service" underline="none">
                      Terms of service
                    </FooterLink>
                    <FooterLink href="/privacy-policy" underline="none">
                      Privacy policy
                    </FooterLink>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <Typography variant="subtitle2" color="secondary" sx={{ fontFamily: 'Lato, sans-serif' }}>
                © 2024 Knacksters. All rights reserved.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2} alignItems="center" sx={{ justifyContent: 'flex-end' }}>
                {socialMedias.map((item, index) => (
                  <Grid item key={index}>
                    <SocialLink underline="none" target={'_blank'} href={item.href}>
                      <CardMedia component={item.component} sx={{ fontSize: 18 }} />
                    </SocialLink>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
